// extracted by mini-css-extract-plugin
module.exports = {"base":"ViewSubscription_base__1gwKi","detailsFlex":"ViewSubscription_detailsFlex__2SLnZ","details":"ViewSubscription_details__2nMEY","cell":"ViewSubscription_cell__3Pu6G"};